import type { Command, CommandContext } from "./Command";
import type { EntityId } from "../../world/Entity";
import { getComponent, PLAYER_CHARACTER_ID } from "../../world/Entity";

export class NavigateCommand implements Command {
  constructor(private readonly portalEntityId: EntityId) {}

  execute(context: CommandContext): void {
    const entity = context.world.getEntity(this.portalEntityId);
    if (!entity) throw new Error(`Portal "${this.portalEntityId}" not found`);
    const portal = getComponent(entity, "portal");
    if (!portal) throw new Error(`"${this.portalEntityId}" is not a portal`);

    context.events.emit("scene:navigate", {
      portalEntityId: this.portalEntityId,
      toScene: portal.toScene,
      spawnPoint: portal.spawnPoint,
    });
    context.world.removeEntityFromScene(PLAYER_CHARACTER_ID);
  }
}
